import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { TgBlackIcon, LabrLogoImg } from "@/assets"
import { openTgLink } from "@/helpers/openTgLink"
import { useAppSelector } from "@/store"
import { AppSelectors } from "@/store/slices/app"
import { Button } from "@/ui/Button"
import { Container } from "@/ui/Container"
import styles from "./NotALabrUser.module.scss"
import { INotALabrUser } from "./types"

export const NotALabrUser: FC<INotALabrUser> = () => {
  const { t } = useTranslation()

  const isLabrUser = useAppSelector(AppSelectors.selectIsLabrUser())

  if (isLabrUser) return null

  return (
    <div className={clsx(styles.NotALabrUser)}>
      <Container
        className={clsx(styles.NotALabrUser_content)}
        triangleBottomPosLeft={"32px"}
        triangleTopPosLeft={"calc(100% - 58px)"}
      >
        <div className={clsx(styles.NotALabrUser_content_title)}>
          <h1>{t("notALabrUser.h1")}</h1>
        </div>
        <div className={clsx(styles.NotALabrUser_content_description)}>
          <LabrLogoImg />
          <p>{t("notALabrUser.h2")}</p>
        </div>
        <div className={clsx(styles.NotALabrUser_content_button)}>
          <Button
            icon={<TgBlackIcon />}
            onClick={() => openTgLink(import.meta.env.VITE_LABR_APP)}
          >
            {t("notALabrUser.toTg")}
          </Button>
        </div>
      </Container>
    </div>
  )
}
